// import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
// import short from "@/data/forms/mixins/short.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
// import afterSearch from "@/data/search/mixins/afterSearch.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";

export default {
  mixins: [dataSources, announcements, routerFunctions],
  data() {
    return {
      results: [],
      totalFound: 0,
      totalSearched: 0,
      indexCounter: 0,
      searchLimit: 100 // limited (default)
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSource", "getCurrentPage", "getUser"])
  },
  methods: {
    checkPreviousResultNoDuplicate(u) {
      // u = did
      let duplicate = false;
      if (this.results.length == 0) {
        // console.log("FIRST RESULT");
        duplicate = true;
      } else {
        // console.log("CHECK DUP.");
        // console.log("ID Searched " + u.basic.id);
        // console.log("ID Previous" + this.results[this.results.length - 1].id);
        if (u.basic.did !== this.results[this.results.length - 1].basic.did) {
          duplicate = true;
        }
      }
      return duplicate;
    },
    checkDuplicate(u) {
      // u = did
      let duplicate = false;
      for (var i = 0; i < this.results.length; i++) {
        if (u === this.results[i].basic.did) {
          duplicate = true;
        }
      }
      return duplicate;
    },
    resetDataForSearch() {
      this.totalFound = 0;
      this.totalSearched = 0;
      this.results = [];
    },
    searchDocuments(search) {
      this.results = []; // reset search
      // Reset Data to begin search
      this.resetDataForSearch();
      // Search Criteria Mode
      let dbs = search.dbs;
      let id = search.id;
      let ft = "";
      if (search.enableFt === true) {
        ft = search.ft.toLowerCase();
      }
      let title = search.title.toLowerCase();
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.limit);
      } else {
        searchLimit = this.searchLimit;
      }
      // search item convet to lower case
      // console.log("");
      // console.log(">>> SEARCH DOCUMENTS <<<");
      // console.log("DOC SEARCH ID            " + id);
      // console.log("DOC SEARCH TITLE         " + title);
      // console.log("FACILITY SEARCH ENABLED  " + search.enableFt);
      // console.log("FACILITY SEARCH TITLE    " + ft);
      // console.log("SEARCH LIMIT             " + searchLimit);
      // eslint-disable-next-line
      dbs.orderBy("basic.idg").limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let docData = doc.data();
            let dbID = doc.data().basic.id;
            let dbTitle = doc.data().basic.title.toLowerCase();
            let dbFt = "";
            if (this.search.enableFt === true) {
              if (
                this.getCurrentPage === "/facilitydashoperations" ||
                this.getCurrentPage === "/facilitydashmaintenance" ||
                this.getCurrentPage === "/facilitydashengineering"
              ) {
                dbFt = this.getUser.pref.select.fname;
                dbFt = dbFt.toLowerCase();
              } else {
                // dbFt = this.getUser.pref.select.fname;
                dbFt = doc.data().link.ft.toLowerCase();
              }
            }

            // console.log("");
            // console.log(">>>>>>> SEARCH FOUND <<<");
            // console.log(search.dbs);
            // console.log("Enable Facility Title   " + search.enableFt);
            // console.log("Enable Facility ONLY    " + search.enableFacilityOnly);
            // console.log("Search ID               " + search.id);
            // console.log("Found ID                " + docData.basic.id);
            // console.log("Search TITLE            " + search.title);
            // console.log("Found TITLE             " + docData.basic.title);
            // console.log("Search FACILITY         " + search.ft);
            // console.log("Found FACILITY          " + docData.link.ft);
            // console.log("");
            // Search
            // CASE 1 ID only at Company
            if (search.id !== "" && search.title === "" && search.ft === "") {
              if (dbID.includes(id)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 2 NAME/TITLE only at Company
              // eslint-disable-next-line
            } else if (search.title !== "" && search.id === "" && search.ft === "") {
              if (dbTitle.includes(title)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 3 NAME/TITLE only + FACILITY SEARCH
              // eslint-disable-next-line
            } else if (
              search.title !== "" &&
              search.id === "" &&
              search.ft !== "" &&
              search.enableFacilityOnly === false
            ) {
              console.log("SEARCH ITEMS with FACILITY TITLE");
              console.log(dbTitle);
              console.log(dbTitle.includes(title));
              console.log(dbFt.includes(ft));
              let docfdid = docData.link.fdid;
              if (
                dbTitle.includes(title) &&
                dbFt.includes(ft) &&
                docfdid !== null &&
                docfdid !== undefined &&
                docfdid !== ""
              ) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // eslint-disable-next-line
              // CASE 4 ID + FACILITY SEARCH
            } else if (
              search.title !== "" &&
              search.id === "" &&
              search.ft !== "" &&
              search.enableFacilityOnly === true
            ) {
              console.log("SEARCH ITEMS with FACILITY ONLY");
              let docfid = docData.link.fdid;
              let thisfdid = this.getUser.pref.select.fdid;
              console.log("DOC  FDID  " + docData.link.fdid);
              console.log("THIS FDID  " + this.getUser.pref.select.fdid);
              console.log("DOC  FDID  " + docData.link.fdid);
              console.log("FACILITY   " + dbTitle);
              console.log("DB FT      " + dbFt);
              console.log("FT         " + ft);
              console.log(dbTitle);
              console.log(dbTitle.includes(title));
              console.log(dbFt.includes(ft));
              if (
                dbTitle.includes(title) &&
                dbFt.includes(ft) &&
                docfid === thisfdid
              ) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // eslint-disable-next-line
              // CASE 4 ID + FACILITY SEARCH
            } else if (
              search.title === "" &&
              search.id !== "" &&
              search.ft !== ""
            ) {
              if (dbID.includes(id) && dbFt.includes(ft)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // eslint-disable-next-line
              // CASE 2 NAME + ID + FACILITY
            } else if (
              search.title !== "" &&
              search.id !== "" &&
              search.ft !== ""
            ) {
              if (
                dbID.includes(id) &&
                dbTitle.includes(title) &&
                dbFt.includes(ft)
              ) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
            } else {
              // eslint-disable-next-line
              if (dbID.includes(id) && dbTitle.includes(title) ) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
            }
            // CASE 3 NAME and ID
            this.totalSearched++;
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          if (this.getCurrentPage === "/registerlist") {
            this.dialog = false;
          }
          this.btnSpinSearchImport = false;
          this.enableSpinBtnAction = false;
          this.enableSpinBtnSearch = false;
          this.enableSpinnerGetMaintStrategy = false;
          this.btnSpinMaintAssuranceSearch = false;
          if (this.results.length === 0) {
            this.generateInfoSnackbar("wplorange0", "No records found.");
            this.enableSpinBtnSearch = false;
          } else {
            // Update Store
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResults", this.results);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.results.length);
            if (search.router === undefined || search.router === true) {
              this.$router.push(this.defineRouter("K6"));
            }
          }
        });
    },
    appendSearchResult(searchResult) {
      // console.log("");
      // console.log("APPEND SEARCH");
      // console.log(searchResult);
      let obj = searchResult;
      if (obj.basic.act === true || obj.basic.act === false) {
        if (obj.basic.tag === "C1") {
          if (obj.pref.search.privacy !== "Private") {
            this.results.push(obj);
          }
        } else {
          this.results.push(obj);
        }
      }
    },
    searchUserRoleAssign(search) {
      this.results = []; // reset search
      // Reset Data to begin search
      this.resetDataForSearch();
      // Search Criteria Mode
      let dbs = search.dbs;
      let title = search.title.toLowerCase();
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.limit);
      } else {
        searchLimit = this.searchLimit;
      }
      // search item convet to lower case
      // eslint-disable-next-line
      dbs.orderBy("basic.did").limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let docData = doc.data();
            let dbTitle = doc.data().char.utitle.toLowerCase();
            // Search
            // CASE 1 ID only
            if (search.title !== "") {
              if (dbTitle.includes(title)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  // console.log("READY to ADD");
                  // console.log(k.basic.id);
                  let obj = Object.assign({}, docData);
                  if (obj.basic.act === true) {
                    this.results.push(obj);
                  }
                }
              }
            }
            // CASE 3 NAME and ID
            this.totalSearched++;
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // this is store update and router
          // this.doAfterSearching(this.results);
          // results
          this.$store.dispatch("changeSearchResults", this.results);
          // eslint-disable-next-line
          this.$store.dispatch("changeSearchResultsCounter", this.results.length);
          this.enableSpinBtnSearch = false;

          if (this.results.length === 0) {
            this.generateInfoSnackbar("wplorange0", "No records found.");
            this.enableSpinBtnSearch = false;
          }
        });
    }
  }
};
